export const docLookupFieldDropdown =  [
  {
    title: "Door Name",
    value: "docName"
  },
  {
    title: "Modified By",
    value: "docModifiedBy"
  }

];



// WEBPACK FOOTER //
// ./src/pages/dockConfigurations/filter/docLookupFieldDropdown.js